import React from "react";
import { useAppSelector } from "../../../../../../redux";
import { Loader, LoaderSizes, Tabs } from "@hid-galaxy-ui/galaxy-react";
import useProductListPageRoute from "../../../../../../hooks/useProductListPageRoute";
import TabContentServiceContract from "./tab-content-service-contract";
import TabContentExternalContract from "./tab-content-external-contract";
import { useLocation } from "react-router-dom";
import "./ServicesAndSubscriptions.scss";

const ServicesAndSubscriptions: React.FC<{}> = () => {
  const [tabSelectedKey, setTabSelectedKey] = React.useState<string>("");
  const [tabsServices, setTabsServices] = React.useState([]);
  const { collection, status: statusPLP } = useAppSelector(
    (state) => state.plp
  );
  const location = useLocation();
  const { getRouteIndex } = useProductListPageRoute();
  const shopifyNavigationHandle = "service-catalog";
  const subCollection = collection[getRouteIndex(shopifyNavigationHandle)];
  const sortedCollection = React.useMemo(() => subCollection, [collection]);

  React.useEffect(() => {
    if (location.state) {
      if (location.state.selectedTab === "manage-contracts") {
        setTabSelectedKey("manage-contracts");
      }
    }
  }, []);

  React.useEffect(() => {
    const subColl = collection[getRouteIndex(shopifyNavigationHandle)];
    if (subColl.length > 0) {
      let TabsMyAccount = subColl.map((collection) => {
        return {
          key: collection?.handle?.trim().toLowerCase().replaceAll("-", "_"),
          label: collection.title,
        };
      });
      TabsMyAccount.push({
        key: "manage-contracts",
        label: "Manage Contracts",
      });
      setTabsServices(TabsMyAccount);
    }
  }, [collection]);

  function onTabClickHandler(e: any, key: string): void {}

  return (
    <div className="services-subscriptions-container">
      {statusPLP.collectionListLoading ? (
        <div className="loading-tabs">
          <Loader variant={LoaderSizes.large} />
        </div>
      ) : tabsServices?.length > 0 ? (
        <Tabs
          theme="frameless"
          selectedKey={tabSelectedKey}
          items={tabsServices.map((tab, index: number) => {
            return {
              key: tab.key,
              label: tab.label,
              content:
                tab.key === "manage-contracts" ? (
                  <TabContentExternalContract />
                ) : (
                  <TabContentServiceContract collectionKey={tab.key} />
                ),
            };
          })}
          onClick={onTabClickHandler}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default ServicesAndSubscriptions;
